module.exports = __webpack_public_path__ + "static/media/18.aa0f794a.JPG";